import React, { useEffect, useState } from 'react'
import { useIntl } from 'react-intl'
import { Dialog } from 'primereact/dialog'
import { LuxButton, LuxCheckboxInput, Color } from '@lux/wardrobe-lib'
import { ProjectApiSurvey } from '@/app/models/projects-service'
import './DialogVisitDownloadSurvey.scss'

const DialogVisitDownloadSurvey = (props: {
    dialogVisible: boolean
    surveys: ProjectApiSurvey[]
    onDownload: (surveyIds: string[]) => void
    onHide: () => void
}) => {
    const { dialogVisible, surveys, onDownload, onHide } = props

    const componentClass = 'smart-modals-dialog-visit-download-survey'

    const [selectedAll, setSelectedAll] = useState(true)
    const [selectedMap, setSelectedMap] = useState<string[]>([])

    const intl = useIntl()

    const onSelectedAll = () => {
        let selected = []
        if (!selectedAll) {
            selected = surveys.map((s) => s.surveyId)
        }
        setSelectedMap(selected)
    }

    const onSelectedSurvey = (surveyId: string) => {
        const selected = selectedMap.findIndex((s) => s === surveyId)
        if (selected > -1) {
            let list = [...selectedMap]
            list.splice(selected, 1)
            setSelectedMap(list)
            return
        }
        setSelectedMap((v) => [...v, surveyId])
    }

    const renderFooter = () => {
        return (
            <div className={`${componentClass}-buttons`}>
                <LuxButton
                    onClick={() => onDownload(selectedMap)}
                    text={intl.formatMessage({
                        id: 'download',
                        defaultMessage: 'Download',
                    })}
                    color={Color.WARNING}
                />
            </div>
        )
    }

    useEffect(() => {
        setSelectedMap(surveys.map((s) => s.surveyId))
    }, [])

    useEffect(() => {
        setSelectedAll(selectedMap.length === surveys.length)
    }, [selectedMap])

    return (
        <Dialog
            header={intl.formatMessage({
                id: 'modals.activity.visit.action.download.survey',
                defaultMessage: 'Download Survey',
            })}
            draggable={false}
            visible={dialogVisible}
            onHide={() => onHide()}
            footer={renderFooter()}
            style={{ width: '50vw' }}
            maskClassName={componentClass}
            breakpoints={{ '960px': '85vw' }}>
            <div>
                <div className={`${componentClass}-description text`}>
                    {intl.formatMessage({
                        id: 'modals.activity.visit.action.download.survey.description',
                        defaultMessage:
                            'To continue, select the surveys you want to export and download',
                    })}
                </div>
            </div>
            <div className={`${componentClass}-content`}>
                <div className={`${componentClass}-checkbox`}>
                    <LuxCheckboxInput
                        label={intl.formatMessage({
                            id: 'modals.filters.label.all',
                            defaultMessage: 'All',
                        })}
                        value={selectedAll}
                        onChangeCallback={onSelectedAll}
                    />
                </div>
                {surveys.map((s) => (
                    <div className={`${componentClass}-checkbox`}>
                        <LuxCheckboxInput
                            label={s.surveyName}
                            value={selectedMap.includes(s.surveyId)}
                            onChangeCallback={onSelectedSurvey.bind(null, s.surveyId)}
                        />
                    </div>
                ))}
            </div>
        </Dialog>
    )
}

export default DialogVisitDownloadSurvey
